import { isNullOrUndefined } from './helpers';

/**
 * Order of priority:
 * 1. relevant union class wage in past
 * 2. relevant cost code wage in past
 * 3. current wage of cost code
 * 4. relevant user wage in past
 * 5. current user wage
 *
 * Mirrors backend/helpers/tasks.js getRelevantWageAndBillingRate
 * All wageHistory arrays are pre-sorted descending by timestamp from the API.
 */
export const getRelevantWageAndBillingRate = ({
  task,
  user,
  costcode,
  unionClass,
}) => {
  const wageHistory = user?.wageHistory ?? [];
  const costcodeWageHistory = costcode?.wageHistory ?? [];
  const classWageHistory = unionClass?.wageHistory ?? [];

  const relevantEndTime = task.endTime || task.otEndTime || task.doubleOTEndTime;
  const wageEntry = wageHistory.find((w) => w.timestamp <= relevantEndTime);
  const costcodeEntry = costcodeWageHistory.find((w) => w.timestamp <= relevantEndTime);
  const classEntry = classWageHistory.find((w) => w.timestamp <= relevantEndTime);

  let hourlyWage = user?.wage || 0;
  let hasCostcodeWage = false;
  let dailyWage = null;

  if (wageEntry) {
    hourlyWage = wageEntry.wage;
  }

  // Current hourly wage
  if (!isNullOrUndefined(costcode?.hourlyWage)) {
    hasCostcodeWage = true;
    hourlyWage = costcode.hourlyWage;
  }

  // Relevant hourly wage
  if (!isNullOrUndefined(costcodeEntry?.hourlyWage)) {
    hasCostcodeWage = true;
    hourlyWage = costcodeEntry.hourlyWage;
  }

  // Current daily wage
  if (!isNullOrUndefined(costcode?.dailyWage)) {
    hasCostcodeWage = true;
    dailyWage = costcode.dailyWage;
    hourlyWage = null;
  }

  // Relevant daily wage
  if (!isNullOrUndefined(costcodeEntry?.dailyWage)) {
    hasCostcodeWage = true;
    dailyWage = costcodeEntry.dailyWage;
    hourlyWage = null;
  }

  // Only use wage multiplier/adjustment if we are using the user wage
  if (!hasCostcodeWage) {
    const useHistory = !isNullOrUndefined(costcodeEntry?.wageAdjustment)
      || !isNullOrUndefined(costcodeEntry?.wageMultiplier);
    hourlyWage += useHistory
      ? (costcodeEntry?.wageAdjustment ?? 0)
      : (costcode?.wageAdjustment ?? 0);
    hourlyWage *= useHistory
      ? (costcodeEntry?.wageMultiplier ?? 1)
      : (costcode?.wageMultiplier ?? 1);
  }

  // Relevant union class wage
  if (!isNullOrUndefined(classEntry?.wage)) {
    hourlyWage = classEntry.wage;
    dailyWage = null;
  }

  return {
    hourlyWage,
    dailyWage,
    hourlyBillingRate: costcodeEntry?.hourlyBillingRate ?? costcode?.hourlyBillingRate,
    dailyBillingRate: costcodeEntry?.dailyBillingRate ?? costcode?.dailyBillingRate,
  };
};

export default {};
